// extracted by mini-css-extract-plugin
export default {"reference":"Popover_reference__Z3VUa","container":"Popover_container__VAU+I","spin":"Popover_spin__k5yUJ"};